// extracted by mini-css-extract-plugin
module.exports = {"navTab":"navTab_navTab__1ZGtN","navTabMobile":"navTab_navTabMobile__XWR-Z"};